import { faQuestionCircle, faSquare } from '@fortawesome/free-regular-svg-icons'
import {
  faCheckSquare,
  faQuestionCircle as faQuestionCircleSolid,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'

import {
  CheckBox,
  CheckBoxIcon,
  CheckBoxLabel,
  HelpContainer,
  HelpIcon,
  HelpText,
} from './style'

type Props = {
  label: string
  onChange: (checked: boolean) => void
  isChecked?: boolean
  help?: string
  color?: string
  margin?: string
}

const Checkbox = ({
  label,
  onChange,
  isChecked = false,
  help,
  color,
  margin,
}: Props) => {
  const [helpOpen, setHelpOpen] = useState<boolean>(false)

  return (
    <CheckBox
      margin={margin}
      onClick={() => {
        onChange(!isChecked)
      }}>
      <CheckBoxIcon color={color}>
        {isChecked ? (
          <FontAwesomeIcon icon={faCheckSquare} />
        ) : (
          <FontAwesomeIcon icon={faSquare} />
        )}
      </CheckBoxIcon>
      <CheckBoxLabel color={color}>{label}</CheckBoxLabel>
      {help ? (
        <HelpContainer
          open={helpOpen}
          onMouseEnter={() => setHelpOpen(true)}
          onMouseLeave={() => setHelpOpen(false)}
          onTouchStart={() => setHelpOpen(!helpOpen)}
          onClick={e => e.stopPropagation()}>
          <HelpIcon color={color}>
            <FontAwesomeIcon
              icon={helpOpen ? faQuestionCircleSolid : faQuestionCircle}
            />
          </HelpIcon>
          <HelpText
            color={'#FFFFFF'}
            backgroundColor={'#FFFFFF'}
            open={helpOpen}>
            {help}
          </HelpText>
        </HelpContainer>
      ) : undefined}
    </CheckBox>
  )
}

export default Checkbox
